import React from "react";
import { useDispatch } from "react-redux";
import Button from "../../components/Button";
import { CardHeader, ColCard, CardTitle } from "../../components/ContentLayout";
import Icon from "../../components/Icon";
import { toggleNotice } from "../../store/actions";
import PencilIcon from "../../assets/images/icon/pencil-icon.svg";

const NoticeWriteBoard = () => {
  const dispatch = useDispatch();

  const writeNotice = () => {
    dispatch(toggleNotice(true));
  };

  return (
    <>
      <ColCard type="light" className="notice-write-board">
        <CardHeader>
          <CardTitle>공지사항 작성</CardTitle>
        </CardHeader>
        <div
          className="notice-write-board-box"
        >
          <Button
            color={"secondary"}
            className="dashboard-notice-write-button"
            onClick={writeNotice}
          >
            <Icon src={PencilIcon}></Icon><br />
            작성하기
          </Button>
        </div>
      </ColCard>
    </>
  );
};

export default NoticeWriteBoard;
